import { render, staticRenderFns } from "./ConfigBase.vue?vue&type=template&id=00aaeb3b&scoped=true&"
import script from "./ConfigBase.vue?vue&type=script&lang=js&"
export * from "./ConfigBase.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBase.vue?vue&type=style&index=0&id=00aaeb3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aaeb3b",
  null
  
)

export default component.exports